import { lazy, ComponentProps } from "react"

export const BottomTabNavigator = lazy(() =>
  import("./BottomTabNavigator").then((m) => ({ default: m.BottomTabNavigator }))
)

export const PlanConsentSuccessScreen = lazy(() =>
  import("../screens/PlanConsent/PlanConsentSuccessScreen").then((m) => ({
    default: m.PlanConsentSuccessScreen,
  }))
)

export const MissingBankConnection = lazy(() =>
  import("../screens/tab-screens/PaymentRequestScreen/TermsNotAccepted").then((m) => ({
    default: m.MissingBankConnection,
  }))
)

export const RecipientDetailsScreen = lazy(() =>
  import("../screens/RecipientDetails/RecipientDetailsScreen").then((m) => ({
    default: m.RecipientDetailsScreen,
  }))
)

export const AccountsScreen = lazy(() =>
  import("../screens/tab-screens/Profile/AccountScreen").then((m) => ({
    default: m.AccountsScreen,
  }))
)

export const PersonalDetailsScreen = lazy(() =>
  import("../screens/PersonalDetailsScreen").then((m) => ({
    default: m.PersonalDetailsScreen,
  }))
)

export const NotificationsSettingsScreen = lazy(() =>
  import("../screens/NotificationsSettings/NotificationsSettingsScreen").then((m) => ({
    default: m.NotificationsSettingsScreen,
  }))
)

export const NotificationsSettingsItemScreen = lazy(() =>
  import("../screens/NotificationsSettings/NotificationsSettingsItemScreen").then((m) => ({
    default: m.NotificationsSettingsItemScreen,
  }))
)

export const ReimbursementsModalStackView = lazy(() =>
  import("../screens/tab-screens/ReimbursementScreen/ReimbursementsModalStack").then((m) => ({
    default: m.ReimbursementsModalStackView,
  }))
)

export const InsuranceConnectionRouter = lazy(() =>
  import("../screens/InsuranceConnection/Router").then((m) => ({
    default: m.InsuranceConnectionRouter,
  }))
)

export const EnableNotificationsScreen = lazy(() =>
  import("../screens/NotificationsSettings/EnableNotificationsScreen").then((m) => ({
    default: m.EnableNotificationsScreen,
  }))
)

export const LoggedOutScreen = lazy(() =>
  import("../screens/LoggedOut").then((m) => ({ default: m.LoggedOutScreen }))
)

export const CardPaymentScreen = lazy(() =>
  import("../screens/tab-screens/CardPaymentScreen/CardPaymentScreen").then((m) => ({
    default: m.CardPaymentScreen,
  }))
)

export const DownloadTheAppScreen = lazy(() =>
  import("../screens/onboarding-flow-v2/DownloadTheAppScreen").then((m) => ({
    default: m.DownloadTheAppScreen,
  }))
)

export const PlanConsentRequestScreenWithGuard = lazy(async () => {
  const [{ PlanConsentRequestScreen }, { TermsNotAcceptedGuard }] = await Promise.all([
    import("../screens/PlanConsent/PlanConsentRequestScreen"),
    import("../screens/tab-screens/PaymentRequestScreen/TermsNotAccepted"),
  ])

  function PlanConsentRequestScreenWithGuard(
    props: ComponentProps<typeof PlanConsentRequestScreen>
  ) {
    return (
      <TermsNotAcceptedGuard>
        <PlanConsentRequestScreen {...props} />
      </TermsNotAcceptedGuard>
    )
  }

  return { default: PlanConsentRequestScreenWithGuard }
})
